import { PCRModel } from 'services/EpdClient';

// Id of c-PCR 021 Furniture; the same in every environment.
export const FURNITURE_CPCR_ID = 'A4E3500E-9346-4598-9BD1-08DAB6704842';

const OTHER_FURNITURE_LABEL = 'Other furniture within c-PCR scope';

type CpcrIdentity = Pick<PCRModel, 'id'> | undefined;

const isFurnitureCpcr = (cpcr: CpcrIdentity): boolean => cpcr?.id?.toLowerCase() === FURNITURE_CPCR_ID.toLowerCase();

/**
 * Product category options for the c-PCR selected in the Compiler. For c-PCR 021 Furniture (recognised by its
 * id only) the options are sorted alphabetically by label with "Other furniture within c-PCR scope" always
 * last; for any other c-PCR the options are returned unchanged (same reference). The input is never mutated.
 */
export const sortCpcrProductCategoryOptions = <T extends { label?: string }>(
  cpcr: CpcrIdentity,
  options: T[] | undefined
): T[] | undefined => {
  if (!options || !isFurnitureCpcr(cpcr)) {
    return options;
  }

  const isOther = (option: T) => option.label === OTHER_FURNITURE_LABEL;

  return [...options].sort((a, b) => {
    if (isOther(a) !== isOther(b)) {
      return isOther(a) ? 1 : -1;
    }
    return (a.label ?? '').localeCompare(b.label ?? '', 'en', { sensitivity: 'base' });
  });
};
